/**
 * Links that came from a text field somebody typed into.
 *
 * Every URL rendered by either app that an admin authored goes through here: the footer socials, the
 * home page's About block, a CMS link, a logo. A `javascript:` href in one of them runs in the visitor's
 * session, and nothing in the settings form prevents one being typed.
 */

/** `http(s)` only. Anything else — `javascript:`, `data:` — is dropped rather than rendered. */
export function safeLink(raw: unknown): string | null {
  if (typeof raw !== 'string' || raw.trim() === '') return null
  try {
    const url = new URL(raw.trim())
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : null
  } catch {
    // A relative path has no protocol to abuse, and the restaurant's own uploads are relative.
    return raw.startsWith('/') ? raw : null
  }
}
